module.exports = __webpack_public_path__ + "img/schema.8b347a4b.png";